import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';

import { type Tag, useAllTags } from 'app/network/listing';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Pressable } from 'react-native';
import { TagsSectionSkeleton } from './tags-section-skeleton';
import { SectionHeader } from './section-header';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

export function usePopularInterestsTags({ enabled = true }: { enabled?: boolean } = {}) {
  return useAllTags(true, { enabled });
}

export function PopularInterests({ onTagPress, tags }: { onTagPress: (tagId: string) => void; tags?: Tag[] }) {
  const { t } = useTranslation('landing-page');
  const initialNumberOfTagsToShow = 8;
  const maxNumberOfTagsToShow = 25;
  const [numberOfTagsToShow, setNumberOfTagsToShow] = useState(initialNumberOfTagsToShow);

  if (tags === undefined) {
    return <TagsSectionSkeleton chipWidths={[70, 90, 60, 100, 75, 85, 65, 95]} />;
  }
  if (tags.length === 0) return null;

  return (
    <Column gap="spacing.general.x3" testID="popular-interests-section">
      <SectionHeader
        title={t('popularInterests')}
        onViewMore={() =>
          setNumberOfTagsToShow((prev) =>
            prev === initialNumberOfTagsToShow ? maxNumberOfTagsToShow : initialNumberOfTagsToShow,
          )
        }
        onViewMoreText={t('landing-page:viewMore')}
        onShowLessText={t('landing-page:viewLess')}
      />
      <Row style={{ flexWrap: 'wrap', gap: theme.spacing['spacing.general.x1'] }}>
        {tags.slice(0, numberOfTagsToShow).map((tag) => (
          <Pressable
            key={tag.id}
            onPress={() => onTagPress(tag.id)}
            style={{
              backgroundColor: theme.colors['surface.tertiary-neutral'],
              borderRadius: theme.borderRadii['radius.full'],
              paddingHorizontal: theme.spacing['spacing.general.x3'],
              paddingVertical: theme.spacing['spacing.general.x1'],
            }}
          >
            <Text fontSize={13} fontWeight="500">
              {tag.tagName}
            </Text>
          </Pressable>
        ))}
      </Row>
    </Column>
  );
}
